import React from 'react';
import { Box, Typography } from '@curves/ui-base';
import { localUser } from "@Util/utils";


const MemberUserBox = (props) => {
    const user = localUser.get();
    const { displayNo, displayName, clubName } = user || {};
    const { children } = props;
    
    const getTrimmedMemberNo = () => {
        // 去除左側的 0
        const lastSix = displayNo.slice(-6);
        const trimmed = lastSix.replace(/^0+/, '') || '0';
        // 填充不足四位數的前導零
        return trimmed.padStart(4, '0');
    }

    return (
        <Box className={'member-user-box'}>
            <div className="avatar-circle-wrapper">
                <img className="avatar-img" src={"/pic/me/user.jpg"} alt={displayName} />    
            </div>
            
            <Typography variant={'h3'}>
                <span className="member-user-name">{displayName}</span>
                <span className="member-club-name">{clubName}</span>
            </Typography>
            <Box className={'member-num-tag'}>
                {`# ${getTrimmedMemberNo()}`}
            </Box>
            {children}
        </Box>
    )
}

export default MemberUserBox;
